import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface SEOBreadcrumbProps {
  items: BreadcrumbItem[];
  variant?: "default" | "light";
}

export const SEOBreadcrumb = ({ items, variant = "default" }: SEOBreadcrumbProps) => {
  const textColor = variant === "light" ? "text-primary-foreground/80" : "text-muted-foreground";
  const hoverColor = variant === "light" ? "hover:text-primary-foreground" : "hover:text-foreground";
  const activeColor = variant === "light" ? "text-primary-foreground" : "text-foreground";
  
  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <ol className={`flex items-center flex-wrap gap-2 text-sm ${textColor}`}>
        <li className="flex items-center">
          <Link
            to="/"
            className={`flex items-center gap-1 ${hoverColor} transition-colors`}
            aria-label="Startseite"
          >
            <Home className="h-4 w-4" />
            <span>Start</span>
          </Link>
        </li>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center gap-2">
              <ChevronRight className="h-4 w-4" />
              {isLast || !item.href ? (
                <span className={`font-medium ${activeColor}`} aria-current="page">
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.href}
                  className={`${hoverColor} transition-colors`}
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
